type Translate = (key: string) => string;

export const getAudienceRows = (t: Translate) => [
  {
    role: t('Credit control'),
    context: t('Accounts receivable'),
    text: t('How much to extend to a new trade account, and when to pull a limit back on an existing one.'),
    fields: t('Score · limit · days beyond terms · judgments'),
  },
  {
    role: t('Credit risk'),
    context: t('Lending, leasing, invoice finance'),
    text: t(
      'Whether to advance against assets a secured party has already claimed, and where you would rank if it went wrong.',
    ),
    fields: t('UCC filings · charges · filed accounts'),
  },
  {
    role: t('Procurement'),
    context: t('Supply chain'),
    text: t(
      'Which suppliers could fail mid-contract, and which single-source dependencies are worth second-sourcing now.',
    ),
    fields: t('Insolvency notices · overdue accounts · score movement'),
  },
  {
    role: t('Finance'),
    context: t('Treasury and FP&A'),
    text: t('Total exposure once subsidiaries are resolved to a parent, and whether provisioning matches the book.'),
    fields: t('Group structure · aggregate limits · ownership'),
  },
  {
    role: t('Sales'),
    context: t('Commercial and revenue ops'),
    text: t('Which prospects can be offered terms at the point of sale without waiting on a manual check.'),
    fields: t('Score · limit · status · CRM writeback'),
  },
  {
    role: t('Compliance'),
    context: t('KYB and onboarding'),
    text: t(
      'Who owns and controls the counterparty, and whether the chain resolves to a person or stops at a nominee.',
    ),
    fields: t('Directors · shareholders · beneficial owners'),
  },
];
